module.exports = __webpack_public_path__ + "static/media/mark-icon-1.5dbbf94c.svg";